import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import TextLink from '@divvy-web/skylab.textlink'

import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import AfterSubmitInfoPageLayout from '@sputnik/pages/PostApplicationPages/AfterSubmitInfoPageLayout'

const SubmissionError = () => {
  const [getClassName] = useNameFormatter('SubmissionError')
  const { formatMessage } = useIntl()
  return (
    <AfterSubmitInfoPageLayout
      buttons={
        <>
          <GoToDashboardButton componentName={getClassName('')} />
        </>
      }
      imageName='submission-error-page'
      infoContent={
        <FormattedMessage
          defaultMessage='It looks like there may have been an issue.'
          id='sputnik.SubmissionError__0wLquI'
        />
      }
      link={
        <TextLink
          className={getClassName('support-link')}
          href='https://help.bill.com/direct/s/?ref=marketing'
          target='_blank'
        >
          <FormattedMessage
            defaultMessage='Contact support'
            id='sputnik.SubmissionError__5CI3KH'
          />
        </TextLink>
      }
      marketing={
        <MarketingContent
          image={{
            alt: formatMessage({
              defaultMessage: 'coworkers sitting next to each other at a table with laptops',
              id: 'sputnik.SubmissionError__4VFaNh',
            }),
            src: 'https://app.divvy.co/assets/stock-photos/credit-application-submission-error.png',
            isRounded: true,
          }}
          pillText={
            <FormattedMessage
              defaultMessage='Testimonial'
              id='sputnik.SubmissionError__MvBefC'
            />
          }
        >
          <MarketingQuote
            designation={
              <FormattedMessage
                defaultMessage='Controller, Murdock Martell'
                id='sputnik.SubmissionError__R7D/wB'
              />
            }
            name={
              <FormattedMessage
                defaultMessage='Marjorie Maas'
                id='sputnik.SubmissionError__SZFzOu'
              />
            }
            quote={
              <FormattedMessage
                defaultMessage='“Bill pay has allowed my clients to improve workflow, internal controls, and banking transactions. <strong>Overall, I see a 50% improvement in operational efficiency</strong>.”'
                id='sputnik.SubmissionError__8CfLdK'
                values={{
                  strong: (chunks) => <b>{chunks}</b>,
                }}
              />
            }
          />
        </MarketingContent>
      }
      title={
        <FormattedMessage
          defaultMessage='Whoops!'
          id='sputnik.SubmissionError__334LMo'
        />
      }
    />
  )
}

export default SubmissionError
